(function () {
  var initialized = false;

  function init() {
    var field = document.querySelector('.custom-field');
    if (!field) return;
    if (initialized) return;
    initialized = true;

    var i18n = {};
    try {
      i18n = JSON.parse(field.getAttribute('data-i18n'));
    } catch (e) { }

    var radios = document.querySelectorAll('input[name="attributes[checkout-info-choice]"]');
    var companyWrapper = document.querySelectorAll('[data-company]');
    var checkoutBtn = document.getElementById('checkout');
    var noCf = document.getElementById('no-cf');
    var noCfWrap = document.querySelector('[data-person]');

    function toggleNoCf() {
      var codeInput = document.getElementById('code');
      if (!noCf || !codeInput) return;
      if (noCf.checked) {
        codeInput.value = '';
        codeInput.readOnly = true;
        codeInput.removeAttribute('required');
        codeInput.setCustomValidity('');
      } else {
        codeInput.readOnly = false;
        codeInput.setAttribute('required', '');
      }
      validateAll();
    }

    function toggleFields() {
      var selected = document.querySelector('input[name="attributes[checkout-info-choice]"]:checked');
      if (!selected || !companyWrapper) return;
      var companyRequiredIds = ['vat', 'uniqueCode', 'pec'];

      if (selected.value === 'PER') {
        companyWrapper.forEach(el => {
          el.setAttribute('hidden', '');
        });
        companyRequiredIds.forEach(function (id) {
          var el = document.getElementById(id);
          if (el) {
            el.removeAttribute('required');
            el.setCustomValidity('');
          }
          var err = document.querySelector('[data-error="' + id + '"]');
          if (err) err.textContent = '';
        });
        if (noCfWrap) noCfWrap.removeAttribute('hidden');
      } else {
        if (noCfWrap) noCfWrap.setAttribute('hidden', '');
        if (noCf) {
          noCf.checked = false;
          toggleNoCf();
        }
        companyWrapper.forEach(el => {
          el.removeAttribute('hidden');
        });
        companyRequiredIds.forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.setAttribute('required', '');
        });
      }
    }

    var validators = {
      code: function (val) {
        if (noCf && noCf.checked) return '';
        if (!val) return i18n.required || '';
        var selected = document.querySelector('input[name="attributes[checkout-info-choice]"]:checked');
        var isPerson = selected && selected.value === 'PER';
        if (isPerson) {
          val = val.toUpperCase().replace(/\s/g, '');
          if (val.length !== 16) return i18n.codice_fiscale_error_length || '';
          if (!/^[A-Z0-9]{16}$/.test(val)) return i18n.codice_fiscale_error_format || '';
        } else {
          // AZI: codice fiscale — only required, no format validation
          return '';
        }
        return '';
      },
      vat: function (val) {
        // AZI: partita iva — only required, no format validation
        if (!val) return i18n.required || '';
        return '';
      },
      uniqueCode: function (val) {
        if (!val) return i18n.required || '';
        val = val.toUpperCase().replace(/\s/g, '');
        if (val.length !== 7) return i18n.uniq_code_error_length || '';
        if (!/^[A-Z0-9]{7}$/.test(val)) return i18n.uniq_code_error_format || '';
        return '';
      },
      pec: function (val) {
        if (!val) return i18n.required || '';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) return i18n.pec_error_format || '';
        return '';
      }
    };

    function validateAll() {
      var selected = document.querySelector('input[name="attributes[checkout-info-choice]"]:checked');
      var isPerson = selected && selected.value === 'PER';
      var allValid = true;

      var codeInput = document.getElementById('code');
      if (codeInput) {
        var codeMsg = validators.code(codeInput.value);
        var codeErr = document.querySelector('[data-error="code"]');
        if (codeErr) codeErr.textContent = codeMsg;
        codeInput.setCustomValidity(codeMsg);
        if (codeMsg) allValid = false;
      }

      if (!isPerson) {
        ['vat', 'uniqueCode', 'pec'].forEach(function (id) {
          var el = document.getElementById(id);
          if (!el) return;
          var msg = validators[id](el.value);
          var errorEl = document.querySelector('[data-error="' + id + '"]');
          if (errorEl) errorEl.textContent = msg;
          el.setCustomValidity(msg);
          if (msg) allValid = false;
        });
      }

      if (checkoutBtn) {
        if (allValid) {
          checkoutBtn.removeAttribute('disabled');
        } else {
          checkoutBtn.setAttribute('disabled', '');
        }
      }
    }

    Object.keys(validators).forEach(function (id) {
      var input = document.getElementById(id);
      var errorEl = document.querySelector('[data-error="' + id + '"]');
      if (!input || !errorEl) return;

      input.addEventListener('input', function () {
        var msg = validators[id](input.value);
        errorEl.textContent = msg;
        input.setCustomValidity(msg);
        validateAll();
      });

      input.addEventListener('blur', function () {
        var msg = validators[id](input.value);
        errorEl.textContent = msg;
        input.setCustomValidity(msg);
        validateAll();
      });
    });

    ['code', 'uniqueCode'].forEach(function (id) {
      var input = document.getElementById(id);
      if (!input) return;
      input.addEventListener('input', function () {
        var cursor = input.selectionStart;
        input.value = input.value.replace(/\s/g, '').toUpperCase();
        input.setSelectionRange(cursor, cursor);
      });
    });

    var vatInput = document.getElementById('vat');
    if (vatInput) {
      vatInput.addEventListener('input', function () {
        var cursor = vatInput.selectionStart;
        vatInput.value = vatInput.value.replace(/\s/g, '');
        vatInput.setSelectionRange(cursor, cursor);
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        toggleFields();
        validateAll();
      });
    });

    if (noCf) {
      noCf.addEventListener('change', toggleNoCf);
    }

    toggleFields();
    validateAll();
  }

  // Try on page load (cart may already have items)
  init();

  // Watch for .custom-field injected dynamically (first product added to cart)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var addedNodes = mutations[i].addedNodes;
      for (var j = 0; j < addedNodes.length; j++) {
        var node = addedNodes[j];
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('custom-field')) {
            initialized = false;
            init();
            return;
          }
          if (node.querySelector && node.querySelector('.custom-field')) {
            initialized = false;
            init();
            return;
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
